module.exports = __webpack_public_path__ + "img/pasture_high.12fe609e.webp";